/**
 * 报警计划报警方式组件
 * 创建时间：2017-05-11
 * 创建人：zhanlz
 * 修改时间：2017-04-18
 */
<template>
    <div>
		<div class="row">
			<div class="col-sm-12 ">
				<div class="module_title"> <span class="focus_color">请指定系统外报警方式</span> </div>
			</div>
		</div>
		<div class="form-horizontal grey_box row pt10px mb10px" v-if="$parent.mode!=2">
			<div class="col-sm-5">
				<form class="form-inline ml10px">
					<div class="form-group">
						<radio v-model="alarmModeInfo.alarmMode" true-value="add" style="margin-top: -3px;"></radio>
					</div>
	                <div class="form-group">
	                	<label class="mr10px ml5px pl10px">添加为常用报警方式</label>
				    	<input type="text" class="form-control" :disabled="!alarmModeStatus" v-model.trim="alarmModeInfo.alarmModeName" style="margin-top: -2px;">
	                </div>
				</form>
			</div>
			<div class="col-sm-5">
				<form class="form-inline ml10px">
				    <div class="form-group">
						<radio v-model="alarmModeInfo.alarmMode" true-value="read" style="margin-top: -3px;"></radio>
					</div>
					<div class="form-group">
						<label class="mr10px ml5px pl10px">从常用报警方式中读取</label>
						<select class="form-control" :disabled="alarmModeStatus" v-model="alarmModeInfo.readAlarmMode" style="width:150px">  
							<option v-for="readAlarm in alarmModeInfo.readAlarmList" :value="readAlarm.id" >{{readAlarm.contactName}}</option>
						</select>
					</div>
				</form>
			</div>
			<div class="col-sm-2 text-right">
				<button class="btn btn-primary " v-if="alarmModeStatus&&permission.indexOf('alarmMode_alarmModeSave') == -1" @click="confirmSaveAlarmMode">保存</button>
				<button class="btn btn-primary " v-if="!alarmModeStatus&&permission.indexOf('alarmMode_alarmModeRead') == -1" @click="readAlarmMode">读取</button>
				<button class="btn btn-primary " v-if="!alarmModeStatus&&permission.indexOf('alarmMode_alarmModeDelete') == -1" @click="confirmDelAlarmMode">删除</button>
			</div>
		</div>
		<div class="row mb15px">
			<div class="col-sm-2">
				<div class="pl50px mt5px">
					<checkbox v-model="alarmModeInfo.mailMode">通过邮箱报警</checkbox>
				</div>
			</div>
			<div class="col-sm-10">
				<input class="form-control" v-model.trim="alarmModeInfo.mailInfo" :disabled="!alarmModeInfo.mailMode" placeholder="请输入接收报警的邮箱地址，输入多个邮箱地址时，以“逗号”分隔。" ref="mailinfo">
			</div>
		</div>
		<div class="row mb15px">
			<span class="col-sm-offset-2 red">为确保您能正常接收邮件，请将邮箱（ op_support@didi-gps.com）加入您的邮箱白名单。参考：
				<a class="red" style="text-decoration: underline;" href="http://help.mail.163.com/faqDetail.do?code=d7a5dc8471cd0c0e8b4b8f4f8e49998b374173cfe9171305fa1ce630d7f67ac28e86c6b6ec2acd66">163、126邮箱</a> 
				<a class="red" style="text-decoration: underline;" href="http://mail.sina.com.cn/help2/2008-08-02-86.html">sina邮箱</a>    
				<a class="red" style="text-decoration: underline;" href="http://service.mail.qq.com/cgi-bin/help?subtype=1&no=113&id=16 ">qq邮箱</a>
			</span>
		</div>
		
		<div class="row mb15px">
			<div class="col-sm-2">
				<div class="pl50px mt5px">
					<checkbox v-model="alarmModeInfo.weixinMode">通过微信报警</checkbox>
				</div>
			</div>
			<div class="col-sm-10">
				<input class="form-control" v-model.trim="alarmModeInfo.weixinInfo" :disabled="!alarmModeInfo.weixinMode" placeholder="请输入接收报警的“获取报警识别号”，输入多个识别号时，以“逗号”分隔。" ref="weixininfo">
				<p class="help-block orange_t">注：通过微信接收报警时，接收人必须首先关注公众号：“DIDI车联网企业版”。然后通过公众号发送“获取报警识别号”，获得对应的“报警识别号。</p>
			</div>
		</div>
		<div class="row mb15px">
			<div class="col-sm-2">
				<div class="pl50px mt5px">
					<checkbox v-model="alarmModeInfo.messageMode">通过短信报警</checkbox>
				</div>
			</div>
			<div class="col-sm-10">
				<input class="form-control" v-model.trim="alarmModeInfo.messageInfo" :disabled="!alarmModeInfo.messageMode" placeholder="请输入接收报警的手机号码，输入多个手机号码时，以“逗号”分隔。" ref="messageinfo">
				<p class="help-block orange_t">注：通过短信报警时，您需要确认您的报警账户的余额是否充足。您当前的报警账户余额为：{{alarmModeInfo.account}}元。</p>
			</div>
		</div>
		<div class="row mb15px">
			<div class="col-sm-2">
				<div class="pl50px mt5px">
					<checkbox v-model="alarmModeInfo.phoneMode">通过电话报警</checkbox>
				</div>
			</div>
			<div class="col-sm-10">
				<input class="form-control" v-model.trim="alarmModeInfo.phoneInfo" :disabled="!alarmModeInfo.phoneMode" placeholder="请输入接收报警的手机号码，输入多个手机号码时，以“逗号”分隔。" ref="phoneinfo">
				<p class="help-block orange_t">注：通过电话报警时，您需要确认您的报警账户的余额是否充足。您当前的报警账户余额为：{{alarmModeInfo.account}}元。</p>
			</div>
		</div>
		<div class="annotation_text row">
			<p>注意：对于报警等级为“紧急报警”的报警计划，您需要至少选择2种以上的报警方式。</p>
		</div>
		
		<!--报警方式保存确认-->
		<tab-modal ref="modalAlarmSave" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModal('modalAlarmSave')">
			{{messageStr}}
			<div slot="footer">
				<button @click="closeModal('modalAlarmSave')" class="btn btn-primary">取消</button>
		        <button @click="saveAlarmMode" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
		<!--报警方式删除确认-->
		<tab-modal ref="modalAlarmDel" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModal('modalAlarmDel')">
			{{messageStr}}
			<div slot="footer">
				<button @click="closeModal('modalAlarmDel')" class="btn btn-primary">取消</button>
		        <button @click="removeAlarmMode" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
	</div>
</template>

<script>
import Radio from 'components/common/Radio' 
import Checkbox from 'components/common/Checkbox' 
import TabModal from 'components/common/TabModal'
import { OPERATE_SUCCESS,OPERATE_EXCEPTION,INFO_EMPTY,SAVE_ENSURE_INFO,SELECT_ENSURE,DELETE_ENSURE_INFO,DELETE_SUCCESS} from 'static/message'
import classlist from 'util/classlist'
export default {
    name: 'AlarmPlanMode',
    components: {
    	Radio,
    	Checkbox,
    	TabModal
    },
    props: {
    	parentid: {
			type: String,
			dafault: ""
		}
    },
    data() {
        return {
        	permission:this.$store.state.permission.permission[this.parentid]?this.$store.state.permission.permission[this.parentid]:[],
        	//报警方式
			alarmModeInfo: {
				alarmMode: "add",			  //报警方式
				readAlarmMode: "",            //设置默认读取方式
				alarmModeName:'',			  //报警方式名称
				readAlarmList: [],            //读取报警方式常用类型
				mailMode: false,			  //邮箱方式
				weixinMode: false,		  	  //微信方式
				messageMode: false,		  	  //短信方式
				phoneMode: false, 		      //电话方式
				mailInfo: '',			  	  //邮箱内容
				weixinInfo: '',			  	  //微信内容
				messageInfo: '',			  //短信内容
				phoneInfo: '',   		      //电话内容
				account: ''   		          //账户余额
			},
			scrollTop:'',
			messageStr:''
        };
    },
    created(){
    	this.$emit('input', this.alarmModeInfo)
    },
    beforeMount(){
    	this.initBalances();
    	this.initEditInfo();
    },
    computed: {
    	//选择报警方式状态(第二步)
	    alarmModeStatus: function () {
	    	return this.alarmModeInfo.alarmMode==='add';
	    }
    },
    methods: {
    	//编辑时初始化信息
    	initEditInfo(){
    		if (this.$parent.mode=='1' || this.$parent.mode=='2'){
    			this.$parent.loadingstatus.mode = true;
    			this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans/' + this.$parent.planid + '/info', {params: {planId:this.$parent.planid}})
					.then((response) => {
						if(response.body.success) {
							let alarmModeInfo = response.body.data;
							this.alarmModeInfo.mailMode = alarmModeInfo.mailEnable === 1;
							this.alarmModeInfo.mailInfo = alarmModeInfo.mailList;
							this.alarmModeInfo.weixinMode = alarmModeInfo.weixinEnable === 1;
							this.alarmModeInfo.weixinInfo = alarmModeInfo.weixinList;
							this.alarmModeInfo.messageMode = alarmModeInfo.msgEnable === 1;
							this.alarmModeInfo.messageInfo = alarmModeInfo.msgList;
							this.alarmModeInfo.phoneMode = alarmModeInfo.telEnable === 1;
							this.alarmModeInfo.phoneInfo = alarmModeInfo.telList;
						} else {
							this.$parent.openModalMsg(response.data.message);
						}
						this.$parent.loadingstatus.mode = false;
					}, (response) => {
						this.$parent.openModalMsg(response.data.message);
						this.$parent.loadingstatus.mode = false;
					})
					.catch((response) => {
						this.$parent.openModalMsg(OPERATE_EXCEPTION);
						this.$parent.loadingstatus.mode = false;
					}	
				)
    		}
    	},
    	//账户余额查询
    	initBalances(){
    		this.$http.get(process.env.API_ROOT + '/alarm/alm-account/balances', {params: {customerId:this.$store.state.user.groupid}})
				.then((response) => {
					if(response.body.success) {
						this.alarmModeInfo.account = response.body.data;
					} else {
						this.$parent.openModalMsg(response.body.data);
					}
				}, (response) => {
					this.$parent.openModalMsg(response.body.data);
				})
				.catch((response) => {
					this.$parent.openModalMsg(OPERATE_EXCEPTION);
				}	
			)
    	},
    	//报警方式获取
		initAlarmMode(){
			this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans/contacts/', {params: {customerId:this.$store.state.user.groupid}})
				.then((response) => {
					if(response.body.success) {
						const res = response.body.data;
						this.alarmModeInfo.readAlarmList = res;
					} else {
						this.$parent.openModalMsg(res.data.message);
					}
				}, (response) => {
					this.$parent.openModalMsg(response.data.message);
				})
				.catch((response) => {
					this.$parent.openModalMsg(OPERATE_EXCEPTION);
				}	
			)
		},
    	//确认保存报警方式
		confirmSaveAlarmMode(){
			if (this.alarmModeInfo.alarmModeName.trim()===""){
				this.$parent.openModalMsg(INFO_EMPTY.replace('{1}','报警方式名称'));
				return;
			}
			if (!this.alarmModeInfo.mailMode && !this.alarmModeInfo.weixinMode && !this.alarmModeInfo.messageMode && !this.alarmModeInfo.phoneMode){
				this.$parent.openModalMsg(INFO_EMPTY.replace('{1}','报警方式'));
				return;
			}
			if (this.alarmModeInfo.mailMode && this.alarmModeInfo.mailInfo==""){
				this.$parent.openModalMsg(INFO_EMPTY.replace('{1}','邮件'));
				this.$refs.mailinfo.focus();
				return;
			}
			if (this.alarmModeInfo.weixinMode && this.alarmModeInfo.weixinInfo==""){
				this.$parent.openModalMsg(INFO_EMPTY.replace('{1}','微信'));
				this.$refs.weixininfo.focus();
				return;
			}
			if (this.alarmModeInfo.messageMode && this.alarmModeInfo.messageInfo==""){
				this.$parent.openModalMsg(INFO_EMPTY.replace('{1}','短信'));
				this.$refs.messageinfo.focus();
				return;
			}
			if (this.alarmModeInfo.phoneMode && this.alarmModeInfo.phoneInfo==""){
				this.$parent.openModalMsg(INFO_EMPTY.replace('{1}','电话'));
				this.$refs.phoneinfo.focus();
				return;
			}
			this.messageStr=SAVE_ENSURE_INFO.replace('{1}','名称').replace('{2}',this.alarmModeInfo.alarmModeName).replace('{3}','报警方式');
			this.openModal("modalAlarmSave");
		},
		//报警方式读取
		readAlarmMode(){
			const index = this.alarmModeInfo.readAlarmList.findIndex(n=> n.id === this.alarmModeInfo.readAlarmMode);
			if (index===-1){
				this.$parent.openModalMsg("读取内容不能为空");
				return;
			}
			let alarmModeInfo =  this.alarmModeInfo.readAlarmList[index];
			this.alarmModeInfo.mailMode = alarmModeInfo.mailEnable === 1;
			this.alarmModeInfo.mailInfo = alarmModeInfo.mailList;
			this.alarmModeInfo.weixinMode = alarmModeInfo.weixinEnable === 1;
			this.alarmModeInfo.weixinInfo = alarmModeInfo.weixinList;
			this.alarmModeInfo.messageMode = alarmModeInfo.msgEnable === 1;
			this.alarmModeInfo.messageInfo = alarmModeInfo.msgList;
			this.alarmModeInfo.phoneMode = alarmModeInfo.telEnable === 1;
			this.alarmModeInfo.phoneInfo = alarmModeInfo.telList;
		},
		//确认删除报警方式
		confirmDelAlarmMode(){
			const index = this.alarmModeInfo.readAlarmList.findIndex(n=> n.id === this.alarmModeInfo.readAlarmMode);
			if (index===-1){
				this.$parent.openModalMsg(SELECT_ENSURE);
				return;
			}
			let name = this.alarmModeInfo.readAlarmList[index].contactName;
			this.messageStr=DELETE_ENSURE_INFO.replace('{1}','名称').replace('{2}',name).replace('{3}','报警方式');
			this.openModal("modalAlarmDel");
		},
		//报警方式删除
		removeAlarmMode(){
			this.$parent.loadingstatus.mode = true;
			this.closeModal("modalAlarmDel");
			this.$http.delete(process.env.API_ROOT + '/alarm/alarm-plans/contacts/'+this.alarmModeInfo.readAlarmMode)
			.then((response) => {
				if(response.body.success) {
					this.$parent.openModalMsg(DELETE_SUCCESS);
					this.initAlarmMode();
				} else {
					this.$parent.openModalMsg(response.body.message);
				}
				this.$parent.loadingstatus.mode = false;
			}, (response) => {
				this.$parent.openModalMsg(response.body.message);
				this.$parent.loadingstatus.mode = false;
			})
			.catch((response) => {
				this.$parent.openModalMsg(OPERATE_EXCEPTION);
				this.$parent.loadingstatus.mode = false;
			})
		},
		//报警方式保存
		saveAlarmMode(){
			this.$parent.loadingstatus.mode = true;
			this.closeModal("modalAlarmSave");
			let param ={
				contactName:this.alarmModeInfo.alarmModeName,
				customerId:this.$store.state.user.groupid,
				mailEnable:this.alarmModeInfo.mailMode?1:0,
				mailList:this.alarmModeInfo.mailInfo,
				msgEnable:this.alarmModeInfo.messageMode?1:0,
				msgList:this.alarmModeInfo.messageInfo,
				telEnable:this.alarmModeInfo.phoneMode?1:0,
				telList:this.alarmModeInfo.phoneInfo,
				weixinEnable:this.alarmModeInfo.weixinMode?1:0,
				weixinList:this.alarmModeInfo.weixinInfo,
			}
			this.$http.post(process.env.API_ROOT + '/alarm/alarm-plans/contacts/', param)
			.then((response) => {
				if(response.body.success) {
					this.$parent.openModalMsg(OPERATE_SUCCESS);
					this.initAlarmMode();
				} else {
					this.$parent.openModalMsg(response.body.message);
				}
				this.$parent.loadingstatus.mode = false;
			}, (response) => {
				this.$parent.openModalMsg(response.body.message);
				this.$parent.loadingstatus.mode = false;
			})
			.catch((response) => {
				this.$parent.openModalMsg(OPERATE_EXCEPTION);
				this.$parent.loadingstatus.mode = false;
			})
		},
		// 消息弹出框相关 
		openModal(ref) {
        	this.$refs[ref].open();
        	classlist.toggleScroll('close','#'+this.parentid,this);
    	},
    	closeModal(ref){
    		this.$refs[ref].close();
    		classlist.toggleScroll('open','#'+this.parentid,this);
    	},
    },
    watch: {
    	alarmModeInfo:{
    		handler(newValue, oldValue) {
　　　　　　		this.$emit('input', this.alarmModeInfo)
　　　　		},
			deep:true
    	},
    	//报警方式数据读取
	    'alarmModeInfo.alarmMode': function () {
	       if(this.alarmModeInfo.alarmMode=="read"){
	       	  	this.initAlarmMode();
	        }
        },
        //通过邮箱报警
	    "alarmModeInfo.mailMode": function () {
	     	if(!this.alarmModeInfo.mailMode){
	     		this.alarmModeInfo.mailInfo = "";
	     	}
		},
		//通过微信报警
		"alarmModeInfo.weixinMode": function (val) {
	     	if(!this.alarmModeInfo.weixinMode){
	     		this.alarmModeInfo.weixinInfo = "";
	     	}
		},
		//通过短信报警
		"alarmModeInfo.messageMode": function () {
	     	if(!this.alarmModeInfo.messageMode){
	     		this.alarmModeInfo.messageInfo = "";
	     	}
		},
		//通过电话报警
		"alarmModeInfo.phoneMode": function () {
	     	if(!this.alarmModeInfo.phoneMode){
	     		this.alarmModeInfo.phoneInfo = "";
	     	}
		}
    }
};
</script>



// WEBPACK FOOTER //
// AlarmPlanMode.vue?c2727182